import request from "./utils/request";
import requestNonAuthenticated from "./utils/requestNonAuthenticated";

export const deel = {
    checkDeelConnection: () => {
        return request('GET', `deel/check-connection`);
    },
    postDeelCode: (code, company) => {
        return requestNonAuthenticated('POST', `deel/callback?code=${code}&company=${company}`);
    },
    disconnectDeel: (deel_connected, company) => {
        return request('PUT', 'deel/disconnect', { deel_connected, company });
    },
    syncedEmployees: (updateExistingUsers, removeNotFoundUsers) => {
        return request('GET', `deel/sync-employees?update_existing_users=${+updateExistingUsers}&remove_users_not_found_in_deel=${+removeNotFoundUsers}`);
    },
}